import * as login from './login'
import * as storage from './storage'

import * as user from './user'
import * as company from './company'
import * as news from './news'

import * as org from './org'
import * as course from './course'
import * as utils from './utils'
import * as train from './train'
import * as suggestion from './suggestion'
import * as resource from './resource'
import * as record from './record'
import * as register from './register'
import * as purchased_resource from './purchased_resource'
const API = {
  ...login,
  ...storage,
  ...user,
  ...company,
  ...org,
  ...course,
  ...news,
  ...utils,
  ...train,
  ...suggestion,
  ...resource,
  ...record,
  ...register,
  ...purchased_resource
}

export default API
